/**
 * IMPORTANT
 * Этот модуль используется в обоих ангуляр приложения
 * Это значит, что модуль будет дважды проинизиализирован код выполненится дважды
 */
export default angular.module('cian.newbuild.filter.stateService', [])

.factory('StateService', () => {
  return {
    email: window._userInfo.email || '',
  };
})
.name;



// WEBPACK FOOTER //
// ./src/serp/services/state.service.js